import LegalPage, { Section, SubSection, LegalList } from "./LegalPage";

export default function AiDisclaimer() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="AI Use & Disclaimer Policy"
      version="1.0"
      effectiveDate="9 February 2026"
      testId="ai-disclaimer-page"
    >
      <Section number="1" title="Artificial Intelligence Features">
        <p>
          The Platform may include AI-assisted functionality designed to support operational efficiency.
          Such features may include:
        </p>
        <LegalList>
          <li>document drafting;</li>
          <li>compliance recommendations;</li>
          <li>report summaries;</li>
          <li>workflow suggestions;</li>
          <li>risk identification;</li>
          <li>action recommendations;</li>
          <li>natural language search;</li>
          <li>other AI-assisted functionality introduced from time to time.</li>
        </LegalList>
        <p>AI Features are intended to assist human decision-making. They do not replace professional judgement.</p>
        <SubSection number="1.1" title="Customer Review Required">
          <p>
            The Customer must independently review all AI-generated outputs before relying upon or
            implementing them. AI-generated content should be considered a draft or recommendation
            unless independently verified by appropriately authorised personnel.
          </p>
        </SubSection>
        <SubSection number="1.2" title="No Professional Advice">
          <p>AI-generated outputs do not constitute:</p>
          <LegalList>
            <li>legal advice;</li>
            <li>regulatory advice;</li>
            <li>food safety advice;</li>
            <li>certification advice;</li>
            <li>quality assurance consultancy;</li>
            <li>engineering advice;</li>
            <li>professional services.</li>
          </LegalList>
          <p>
            Customers remain responsible for determining whether AI-generated outputs are appropriate
            for their own operations.
          </p>
        </SubSection>
        <SubSection number="1.3" title="AI Limitations">
          <p>
            The Customer acknowledges that artificial intelligence may produce inaccurate, incomplete,
            outdated or inappropriate outputs. Accordingly, Vanguard Beacon does not warrant that
            AI-generated content will be accurate, complete or suitable for any particular purpose.
          </p>
        </SubSection>
      </Section>

      <Section number="2" title="Contact Information">
        <p>Questions regarding this AI Use &amp; Disclaimer Policy may be directed to:</p>
        <p>
          <strong>Vanguard Beacon</strong>
          <br />
          Email: <a href="mailto:hello@vanguardbeacon.com" className="text-brand-orange hover:underline">hello@vanguardbeacon.com</a>
          <br />
          Website: <a href="https://vanguardbeacon.com" className="text-brand-orange hover:underline">https://vanguardbeacon.com</a>
        </p>
      </Section>
    </LegalPage>
  );
}
